// KitchenStock.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import AdminHeader from "./components/AdminHeader";

function KitchenStock() {
  const [selectedKitchenId, setSelectedKitchenId] = useState("");

  useEffect(() => {
    const storedId = localStorage.getItem("admin_kitchen_id");
    if (storedId) {
      setSelectedKitchenId(storedId);
    }
  }, []);

  console.log(selectedKitchenId)

  const [kitchens, setKitchens] = useState([]);
  const [stockItems, setStockItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [stockOptions, setStockOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [quantityFilter, setQuantityFilter] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  // const totalPages = Math.ceil(stockItems.length / itemsPerPage);

  const getQuantityColor = (qty, min, max) => {
    const median = (min + max) / 2;
    if (qty <= min) return "red";
    if (qty > min && qty < median) return "orange";
    if (qty >= median && qty < max) return "orange";
    if (qty >= max) return "green";
    return "black";
  };

  const filteredStockItems = stockItems.filter((item) => {
    const nameMatch = item.stock_name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());

    const qty = parseFloat(item.quantity);
    const min = parseFloat(item.min_range);
    const max = parseFloat(item.max_range);
    const color = getQuantityColor(qty, min, max);

    let colorMatch = true;
    if (quantityFilter === "red") colorMatch = color === "red";
    else if (quantityFilter === "orange") colorMatch = color === "orange";
    else if (quantityFilter === "green") colorMatch = color === "green";

    return nameMatch && colorMatch;
  });

  const paginatedStockItems = filteredStockItems.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(filteredStockItems.length / itemsPerPage);

  // const paginatedStockItems = stockItems.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage
  // );

  useEffect(() => {
    fetch("https://ims-backend.indevconsultancy.in/api/kitchens/")
      .then((res) => res.json())
      .then((data) => setKitchens(data));
  }, []);

  useEffect(() => {
    if (selectedKitchenId) {
      fetchStockItems();
    }
  }, [selectedKitchenId]);

  const fetchStockItems = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `https://ims-backend.indevconsultancy.in/api/kitchen-stock-reports/by-kitchen/${selectedKitchenId}/`
      );
      const data = await res.json();
      setStockItems(data);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error loading stock items:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (item) => {
    setMaxValue(item.max_range);
    setMinValue(item.min_range);
    setItemId(item.item_id);
    document.getElementById("editModalBtn").click();
  };

  const [maxValue, setMaxValue] = useState("");
  const [minValue, setMinValue] = useState("");
  const [itemId, setitemid] = useState("");
  const [quantity_old, setiQuantityOld] = useState("");
  const [itemNamee, setitemName] = useState("");
  const [newQuantity, setnewQuantity] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      max_range: maxValue,
      min_range: minValue,
      item_id: itemId,
      kitchen_id: selectedKitchenId,
      newQuantity: newQuantity,
      quantity_old: quantity_old,
    };

    try {
      const response = await fetch(
        "https://api-ims.indevconsultancy.in/stoct-update.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        const data = await response.json();
        console.log("Stock updated:", data);
              fetchStockItems();

        setMaxValue("");
        setMinValue("");
        setMinValsetiQuantityOldue("");
        setiQuantityOld("");
        setitemName("");
        setitemid("");
        setnewQuantity("");

      } else {
        const errorText = await response.text();
        console.error("Failed to update stock:", errorText);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  useEffect(() => {
    axios
      .get("https://ims-backend.indevconsultancy.in/api/stocks/")
      .then((res) => setStockOptions(res.data))
      .catch((err) => console.error("Error fetching stock options:", err));
  }, []);

  return (
    <>
      <AdminHeader />
      <div className="container mt-3">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5>Kitchen to View Stock</h5>
          </div>

          <div className="card-body">
            <div className="row mb-3 align-items-end">
              <div className="col-md-6">
                <label className="form-label">Kitchen</label>
                <select
                  className="form-select"
                  value={selectedKitchenId}
                  onChange={(e) => setSelectedKitchenId(e.target.value)}
                >
                  <option value="">-- Select Kitchen --</option>
                  {kitchens.map((kitchen) => (
                    <option key={kitchen.kitchen_id} value={kitchen.kitchen_id}>
                      {kitchen.kitchen_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {selectedKitchenId && (
              <>
                <h6 className="mt-3">
                  Stock for:{" "}
                  {
                    kitchens.find(
                      (k) => k.kitchen_id === parseInt(selectedKitchenId)
                    )?.kitchen_name
                  }
                </h6>

                <div className="row mb-3">
                  <div className="col-md-8 d-flex flex-wrap gap-2 mt-2 mt-md-0">
                    <button
                      className="btn btn-sm"
                      style={{ color: "red" }}
                      onClick={() => {
                        setQuantityFilter("red");
                        setCurrentPage(1);
                      }}
                    >
                      ● Below Min
                    </button>
                    <button
                      className="btn btn-sm"
                      style={{ color: "orange" }}
                      onClick={() => {
                        setQuantityFilter("orange");
                        setCurrentPage(1);
                      }}
                    >
                      ● Between Min & Max
                    </button>
                    <button
                      className="btn btn-sm"
                      style={{ color: "green" }}
                      onClick={() => {
                        setQuantityFilter("green");
                        setCurrentPage(1);
                      }}
                    >
                      ● Above Max
                    </button>
                    <button
                      className="btn btn-outline-dark btn-sm"
                      onClick={() => {
                        setQuantityFilter("");
                        setCurrentPage(1);
                      }}
                    >
                      Clear Filter
                    </button>
                  </div>

                  <div className="col-md-4">
                    <input
                      type="text"
                      placeholder="Search by item name"
                      className="form-control"
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                      }}
                    />
                  </div>
                </div>
                <div className="table-responsive mt-3">
                  {/* <div className="row mb-3">
                    <div className="col-md-4">
                      <input
                        type="text"
                        placeholder="Search by item name"
                        className="form-control"
                        value={searchTerm}
                        onChange={(e) => {
                          setSearchTerm(e.target.value);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                    <div className="col-md-8 d-flex flex-wrap gap-2 mt-2 mt-md-0">
                      <button
                        className="btn btn-sm"
                        style={{ color: "red" }}
                        onClick={() => {
                          setQuantityFilter("red");
                          setCurrentPage(1);
                        }}
                      >
                        ● Below Min
                      </button>
                      <button
                        className="btn btn-sm"
                        style={{ color: "orange" }}
                        onClick={() => {
                          setQuantityFilter("orange");
                          setCurrentPage(1);
                        }}
                      >
                        ● Between Min & Max
                      </button>
                      <button
                        className="btn btn-sm"
                        style={{ color: "green" }}
                        onClick={() => {
                          setQuantityFilter("green");
                          setCurrentPage(1);
                        }}
                      >
                        ● Above Max
                      </button>
                      <button
                        className="btn btn-outline-dark btn-sm"
                        onClick={() => {
                          setQuantityFilter("");
                          setCurrentPage(1);
                        }}
                      >
                        Clear Filter
                      </button>
                    </div>
                  </div> */}

                  <table className="table text-center table-bordered table-striped">
                    <thead className="bg-primary text-white">
                      <tr>
                        <th>S.No</th>
                        <th>Item</th>
                        <th>Quantity</th>
                        <th>Max Quantity</th>
                        <th>Min Quantity</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="6">Loading...</td>
                        </tr>
                      ) : paginatedStockItems.length > 0 ? (
                        paginatedStockItems.map((item, index) => (
                          <tr key={index}>
                            <td>
                              {(currentPage - 1) * itemsPerPage + index + 1}
                            </td>
                            <td>
                              {item.stock_name} ({item.unit})
                            </td>
                            <td
                              style={{
                                color: getQuantityColor(
                                  +item.quantity,
                                  +item.min_range,
                                  +item.max_range
                                ),
                              }}
                            >
                              {parseFloat(item.quantity).toFixed(2)}
                            </td>
                            <td>{item.max_range}</td>
                            <td>{item.min_range}</td>
                            <td>
                              {/* <button
                                className="btn btn-sm text-white"
                                style={{ background: "#28a745" }}
                                onClick={() => handleEdit(item)}
                              >
                                <i className="fas fa-edit"></i>
                              </button> */}
                              <button
                                className="btn btn-success btn-sm"
                                type="button"
                                data-bs-toggle="modal"
                                data-bs-target="#editModal"
                                onClick={() => {
                                  setMinValue(item.min_range);
                                  setMaxValue(item.max_range);
                                  setitemid(item.item_id);
                                  setiQuantityOld(item.quantity);
                                  setitemName(item.stock_name);
                                  setnewQuantity(item.quantity);
                                }}
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6">No stock data available.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {stockItems.length > itemsPerPage && (
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>
                    <span>
                      Page {currentPage} of {totalPages}
                    </span>
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={() =>
                        setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                      }
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>

        {/* Trigger for modal */}
        <button
          id="editModalBtn"
          data-bs-toggle="modal"
          data-bs-target="#editModal"
          style={{ display: "none" }}
        ></button>


         {/* Modal for Editing Stock Range */}
      <div className="modal fade" id="editModal" tabIndex="-1" aria-labelledby="editModalLabel" aria-hidden="true" >

        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title" id="editModalLabel">
                  Edit Stock Range
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="">items Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter items Name"
                      value={itemNamee} readOnly
                      onChange={(e) => setitemName(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="">Available Quantity</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Available Quantity"
                      value={quantity_old} disabled
                      onChange={(e) => quantity_old(e.target.value)}
                    />
                  </div>
                  <div className="col-md-12 mb-3">
                    <label htmlFor="">Update Quantity</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Update Quantity"
                      value={newQuantity}
                      onChange={(e) => setnewQuantity(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="">Max Value</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Max Value"
                      value={maxValue}
                      onChange={(e) => setMaxValue(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="">Min Value</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Min Value"
                      value={minValue}
                      onChange={(e) => setMinValue(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      </div>
    </>
  );
}

export default KitchenStock;
